var lib = {exports: {}};

export { lib as __module };
